import { categoryIcon } from "@/api/utils";
import { SubmittalProps } from "@/interfaces/submittal_types";
import { HistoryCardBase, formatDate, formatDateTime } from "./Utils/CardHelper";


export function HistorySubmittalCard({ submittal }: { submittal: SubmittalProps; }) {
    return (
        <HistoryCardBase key={submittal.submittal_id}>
            <div className="flex justify-between">
                <div className="flex flex-row items-center">
                    {categoryIcon(submittal.category) && <img src={categoryIcon(submittal.category) ?? ''} alt="" className="w-5 h-5 mr-2" />}
                    <h3>Submittal:<span className="font-bold"> {submittal.category}</span> </h3>
                </div>
                <h4>Project:<span className="font-bold"> {submittal.project}</span></h4>
            </div>

            <div className="flex justify-between">
                <p>Assigned to:<span className="font-bold"> {submittal.assigned_to}</span></p>
                <p>Received on:<span className="font-bold"> {formatDate(submittal.received_date)}</span></p>
                <p>{submittal.completed_at ? <span className="text-green-700">Completed on: {formatDateTime(submittal.completed_at)}</span> : <span className="text-red-700">Not Completed</span>}</p>
            </div>
        </HistoryCardBase>
    );
}
